// Docs.conviva.ai in production/productionbackup; docs1.conviva.ai for every
// other env (qe/dev/stag/etc.). Old /learning-center/... URLs on pulse.conviva.com
// have been rewritten to the new docs.conviva.ai site — see
// conviva-docs/vercel.json for the authoritative 1091-entry redirect table.
const DOCS_HOST = ['production', 'productionbackup'].includes(process.env.NODE_CONFIG_ENV as string)
  ? 'https://docs.conviva.ai'
  : 'https://docs1.conviva.ai';

export const docsUrl = (path: string): string =>
  `${DOCS_HOST}${path.startsWith('/') ? '' : '/'}${path}`;

// Per-page constants. Names describe the destination; the underlying URL can
// change without touching call sites.
export const AUTO_INSIGHTS_HELP = docsUrl('/sei/video/automatic-insights/');
export const AI_ALERT_MINS_WITH_X_METRICS_HELP = docsUrl('/sei/app/metrics/');
export const WHATS_NEW_NEXA_HELP = docsUrl('/nexa/whats-new-nexa/');
export const DIMENSION_MANAGEMENT_HELP = docsUrl(
  '/sei/video/basics/settings/dimension-management/',
);
export const AI_ALERT_EMAIL_SUBSCRIPTION_HELP = docsUrl(
  '/sei/video/alerts/ai-alert-email-subscription-1474838/',
);
export const NEXA_INTRODUCTION_HELP = docsUrl('/nexa/nexa-introduction/');
export const AI_ALERTS_HELP = docsUrl('/sei/app/ai-alerts/');
export const USER_MANAGEMENT_HELP = docsUrl('/sei/video/basics/settings/user-management-beta/');
export const MANAGING_FILTERS_HELP = docsUrl('/sei/video/basics/filters/managing-filters-820940/');
export const VIEWER_MODULE_WHATS_CHANGING_HELP = docsUrl(
  '/sei/video/ea-features/viewer-module-whats-changing/',
);
export const TRENDS_DYNAMIC_Y_AXIS_HELP = docsUrl(
  '/sei/video/performance-analysis/#dynamic_y_axis',
);
export const USAGE_DB_HELP = docsUrl('/common/a-common/usage-db/');
export const API_MANAGEMENT_HELP = docsUrl('/sei/video/api-mgt/api-management-4129047/');
